.ak{flex:1;}